import { createSlice } from '@reduxjs/toolkit';

export const { actions, reducer } = createSlice({
    name: 'compatibility',
    initialState: {
        sceneVersion: 0
    },
    reducers: {}
});